import { useRouter } from 'next/router';
import FormCommon from './FormCommon';
import { useScheduledContent } from '@/utils/hooks/useScheduledContent';

export const channelObj = {
    'chat-channel': 'chat channel',
    community: 'community',
    'social-media': 'social media',
    'SPF-dpux': 'SPF dpux',
};

export default function QuoteForm({ callback, simple }: any) {
    const { pathname, query, locale = 'us' } = useRouter();
    const IS_COSTCO = query?.source === 'costco' && locale === 'us' && ['/ef-quote-form'].includes(pathname);
    const THEME_WHITE = ['/ef-quote-form', '/delta-pro-3-portable-power-station', '/calculators/delta-pro-ultra', '/power-preparedness'];
    const theme = THEME_WHITE.includes(pathname) ? 'white' : 'black';

    const isNew = useScheduledContent({
        '2025/01/01 10:00:00': false,
        '2026/01/11 15:00:00': true,
    });

    let data: any = {
        theme,
        isPrivacy: true,
        isSubscribe: true,
        isRecaptcha: true,
        list: [
            {
                itemKey: 'fullName',
                itemVal: '',
                isRequire: true,
                formType: 'input',
                formWidth: '50',
                placeholder: 'Full Name*',
                emptyTips: 'Full Name cannot be empty.',
                maxLen: '10',
            },
            {
                itemKey: 'zipCode',
                itemVal: '',
                formType: 'input',
                isRequire: true,
                formWidth: '50',
                emptyTips: 'ZIP Code cannot be empty',
                placeholder: 'ZIP Code (Optional)*',
            },
            {
                itemKey: 'state',
                itemVal: '',
                formType: 'select',
                isRequire: true,
                theme,
                isSelectInterface: !IS_COSTCO,
                selectList: IS_COSTCO
                    ? [
                          { label: 'California', value: 'California', stateCode: 'CA' },
                          { label: 'Texas', value: 'Texas', stateCode: 'TX' },
                          { label: 'Florida', value: 'Florida', stateCode: 'FL' },
                          { label: 'Georgia', value: 'Georgia', stateCode: 'GA' },
                          { label: 'Maryland', value: 'Maryland', stateCode: 'MD' },
                          { label: 'Missouri', value: 'Missouri', stateCode: 'MO' },
                          { label: 'New Jersey', value: 'New Jersey', stateCode: 'NJ' },
                          { label: 'New York', value: 'New York', stateCode: 'NY' },
                          { label: 'North Carolina', value: 'North Carolina', stateCode: 'NC' },
                          { label: 'Pennsylvania', value: 'Pennsylvania', stateCode: 'PA' },
                          { label: 'Virginia', value: 'Virginia', stateCode: 'VA' },
                          {
                              label: 'More regions will be coming soon',
                              value: 'More regions will be coming soon',
                          },
                      ]
                    : undefined,
                formWidth: '50',
                placeholder: 'State*',
                emptyTips: 'Please select a state.',
            },
            {
                itemKey: 'phone',
                itemVal: '',
                formType: 'input',
                isRequire: true,
                formWidth: '50',
                placeholder: 'Phone Number*',
                emptyTips: 'Phone Number is invalid or cannot be empty.',
            },
            {
                itemKey: 'email',
                itemVal: '',
                formType: 'email',
                isRequire: true,
                formWidth: '50',
                placeholder: 'Email*',
                emptyTips: 'Email cannot be empty.',
            },
            {
                itemKey: 'bestTime',
                itemVal: '',
                formType: 'date',
                isRequire: true,
                formWidth: '50',
                emptyTips: 'Preferred Contact Date cannot be empty.',
                placeholder: 'Preferred Contact Date*',
            },
            {
                itemKey: 'bestTimeRange',
                itemVal: '',
                formType: 'select',
                isRequire: true,
                theme,
                isSelectInterface: false,
                selectList: [
                    {
                        label: 'Morning',
                        value: 'Morning',
                    },
                    {
                        label: 'Noon',
                        value: 'Noon',
                    },
                    {
                        label: 'Night',
                        value: 'Night',
                    },
                ],
                formWidth: '50',
                emptyTips: 'Preferred Contact Time cannot be empty.',
                placeholder: 'Preferred Contact Time*',
            },
            {
                itemKey: 'products',
                itemVal: '',
                formType: 'select',
                isRequire: true,
                theme,
                isSelectInterface: false,
                selectList: [
                    {
                        label: 'DELTA Pro Ultra X',
                        value: 'DELTA Pro Ultra X',
                    },
                    {
                        label: 'DELTA Pro Ultra',
                        value: 'DELTA Pro Ultra',
                    },
                    {
                        label: 'DELTA Pro 3',
                        value: 'DELTA Pro 3',
                    },
                ],
                formWidth: '50',
                emptyTips: 'Interested Products cannot be empty.',
                placeholder: 'Interested Products*',
            },
            {
                formType: 'inputAndCheckbox',
                itemKey: 'answer6',
                itemVal: '',
                formWidth: '100',
                data: [
                    {
                        formType: 'input',
                        paramsKey: 'answer6Pre',
                        // number: true,
                        itemKey: 'answer6_number',
                        maxLen: '50',
                        itemVal: '',
                        isRequire: false,
                        formWidth: '50',
                        suffix: ' panel',
                        label: 'How many solar panels do you have (Fill in the amount, watts & open circuit voltage (if possible))?',
                    },
                    {
                        formType: 'checkbox',
                        paramsKey: 'answer6Sub',
                        itemKey: 'answer6_checkbox',
                        itemVal: [],
                        isRequire: false,
                        formWidth: '50',
                        selectList: [
                            {
                                label: 'rooftop solar panels',
                                value: 'rooftop solar panels',
                            },
                            {
                                label: 'portable solar panels',
                                value: 'portable solar panels',
                            },
                        ],
                    },
                ],
            },
            {
                itemKey: 'answer7',
                itemVal: '',
                formType: 'textarea',
                isRequire: false,
                formWidth: '100',
                maxLen: 200,
                placeholder: 'Provide answers here:',
                // emptyTips: 'Message cannot be empty.',
                label: 'What are your essential household appliances?',
            },
        ],
    };

    if (IS_COSTCO) {
        data.list.pop();
        data.list.pop();
    }

    // 渠道情况下字段比较少
    const IS_QUOTE_FORM = ['/ef-quote-form'].includes(pathname);
    const queryChannel = channelObj[query.channel as 'community'];
    // 可以选择兴趣的渠道
    const IS_INTEREST = [channelObj['chat-channel'], channelObj.community, channelObj['social-media']];
    // 可以选择兴趣的页面
    const IS_INTEREST_PAGE = [
        {
            url: '/battery-backup-for-home',
            locales: ['us'],
        },
        {
            url: '/power-preparedness',
            locales: ['us'],
        },
    ].some((item) => item.url === pathname && item.locales.includes(locale));

    if (simple) {
        data = {
            theme,
            isPrivacy: true,
            isSubscribe: true,
            isRecaptcha: true,
            list: [
                {
                    itemKey: 'fullName',
                    itemVal: '',
                    isRequire: true,
                    formType: 'input',
                    formWidth: '50',
                    placeholder: 'Full Name*',
                    emptyTips: 'Full Name cannot be empty.',
                    maxLen: '10',
                },
                ...(isNew
                    ? [
                          {
                              itemKey: 'zipCode',
                              itemVal: '',
                              formType: 'input',
                              isRequire: true,
                              formWidth: '50',
                              emptyTips: 'ZIP Code cannot be empty',
                              placeholder: 'ZIP Code*',
                          },
                          {
                              itemKey: 'state',
                              itemVal: '',
                              formType: 'select',
                              isRequire: true,
                              theme,
                              isSelectInterface: true,
                              selectList: undefined,
                              formWidth: '50',
                              placeholder: 'State*',
                              emptyTips: 'Please select a state.',
                          },
                      ]
                    : []),
                {
                    itemKey: 'phone',
                    itemVal: '',
                    formType: 'input',
                    isRequire: true,
                    formWidth: '50',
                    placeholder: 'Phone Number*',
                    emptyTips: 'Phone Number is invalid or cannot be empty.',
                },
                {
                    itemKey: 'email',
                    itemVal: '',
                    formType: 'email',
                    isRequire: true,
                    formWidth: '100',
                    placeholder: 'Email*',
                    emptyTips: 'Email cannot be empty.',
                },
                ...(isNew
                    ? []
                    : [
                          {
                              itemKey: 'installAssessFlag',
                              itemVal: false,
                              formType: 'agreement',
                              isRequire: false,
                              formWidth: '100',
                              title: 'I want to schedule an appointment for a free on-site installation assessment.',
                              desc: 'Available only in select cities (Los Angeles, San Jose, Houston, Dallas, and Miami). Offer ends January 11, 2026.',
                          },
                      ]),
            ],
        };
        if (IS_INTEREST_PAGE || (IS_INTEREST.includes(queryChannel) && IS_QUOTE_FORM && locale === 'us')) {
            const products = {
                itemKey: 'products',
                itemVal: '',
                formType: 'select',
                isRequire: true,
                theme,
                isSelectInterface: false,
                selectList: [
                    {
                        label: 'DELTA Pro Ultra X',
                        value: 'DELTA Pro Ultra X',
                    },
                    {
                        label: 'DELTA Pro Ultra',
                        value: 'DELTA Pro Ultra',
                    },
                    {
                        label: 'DELTA Pro 3',
                        value: 'DELTA Pro 3',
                    },
                ],
                formWidth: '50',
                emptyTips: 'Interested Products cannot be empty.',
                placeholder: 'Interested Products*',
            };
            if (isNew) {
                data.list[data.list.length - 1].formWidth = '50';
                data.list.push(products);
            } else {
                data.list[data.list.length - 2].formWidth = '50';
                data.list.splice(data.list.length - 1, 0, products);
            }
        }
    }

    return (
        <>
            <FormCommon id={`111`} data={data} callback={callback} channel={IS_QUOTE_FORM ? queryChannel : undefined} />
        </>
    );
}
